import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AdminAuthService } from '@app/services/admin-auth/admin-auth.service';
import { AdminBootstrapService } from '@app/services/admin-bootstrap/admin-bootstrap.service';
import { AdminTenantService } from '@app/services/admin-tenant/admin-tenant.service';
import { catchError, map, of } from 'rxjs';

export const homeRouteGuard: CanActivateFn = () => {
  const adminTenantService = inject(AdminTenantService);
  const bootstrapService = inject(AdminBootstrapService);
  const adminAuthService = inject(AdminAuthService);
  const router = inject(Router);

  return bootstrapService.ensureTenantLoaded().pipe(
    map(() =>
      adminTenantService.isSsoOAuthTenant()
        ? router.parseUrl(adminTenantService.getDefaultLandingRoute())
        : true
    ),
    catchError(() => {
      adminAuthService.signOutAndRedirect();
      return of(false);
    })
  );
};
